import { ApolloError, useQuery } from '@apollo/client';

import {
  AscPeriodLockStatusFragment,
  GET_ASC_PERIOD_LOCK_STATUS,
  GetAscPeriodLockStatusQuery,
  GetAscPeriodLockStatusQueryVariables,
  PeriodName,
} from '@neo.tax/shared';

export type UseAscPeriodLockStatus = {
  lockStatus: AscPeriodLockStatusFragment | null;
  loading: boolean;
  error?: ApolloError;
};

export const useAscPeriodLockStatus = ({
  fiscalYearId,
  periodName,
  skip,
}: {
  fiscalYearId: string;
  periodName: PeriodName;
  /** For callers that never read the status, so they do not pay for a query they throw away. */
  skip?: boolean;
}): UseAscPeriodLockStatus => {
  const { data, error, loading } = useQuery<GetAscPeriodLockStatusQuery, GetAscPeriodLockStatusQueryVariables>(
    GET_ASC_PERIOD_LOCK_STATUS,
    { variables: { fiscalYearId, periodName }, skip },
  );

  return {
    lockStatus: data?.getAscPeriodLockStatus ?? null,
    loading,
    error,
  };
};
